// Every switch on a UOS panel is offered that panel's full SSR list, so nothing
// stops two of them landing on the same SSR while the form is being filled in.
// Confirm is where that gets caught — this reports it per panel, one entry per
// UOS that has at least one doubled-up SSR.
export const duplicateSSRsByUOS = (switches) => {
  const countsByUOS = new Map();

  (switches ?? []).forEach((eachSwitch) => {
    const UOS = eachSwitch?.UOS;
    // A switch with no panel yet already gets its own '— no UOS assigned'
    // problem, and grouping them all under '' would invent a panel.
    if (!UOS) return;

    if (!countsByUOS.has(UOS)) countsByUOS.set(UOS, new Map());
    const counts = countsByUOS.get(UOS);

    // Counted once per switch, not once per entry: a switch holding the same
    // SSR twice is still a single claim on it, and counting occurrences would
    // flag a lone switch as a duplicate.
    const ssrKeys = new Set(
      (Array.isArray(eachSwitch?.selectedSSR) ? eachSwitch.selectedSSR : [])
        .flatMap((entry) => Object.keys(entry ?? {})),
    );

    ssrKeys.forEach((key) => counts.set(key, (counts.get(key) ?? 0) + 1));
  });

  return [...countsByUOS.entries()]
    .map(([UOS, counts]) => ({
      UOS,
      ssrs: [...counts.entries()]
        .filter(([, count]) => count > 1)
        .map(([key]) => key),
    }))
    .filter(({ ssrs }) => ssrs.length > 0);
};
